import { Ng2StateDeclaration, Transition } from '@uirouter/angular';
import { FiAuthenticateLoginComponent } from '@fi-app/authenticate/login/login.component';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { PageTitleService } from '@fi-app/utilities/fi-services/page-title.service';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';

export const FiAuthStatesLoginAuthState: Ng2StateDeclaration = {
    name: FiStateNames.Login.Auth,
    url: '?{:magicLink}&{:autoLogin}',
    component: FiAuthenticateLoginComponent,
    resolve: {
        magicLink: [FiStateService, Transition, FiAuthStatesLoginAuthResolve_magicLink_resolveFunc],
        autoLogin: [FiStateService, Transition, FiAuthStatesLoginAuthResolve_autoLogin_resolveFunc],
        pageTitle: [PageTitleService, FiAuthStatesLoginAuthResolve_pageTitle_resolveFunc],
        checkAuthenticated: [FiStateService, Transition, FiAuthStatesLoginAuthResolve_checkAuthenticated_resolveFunc],
    },
};

export function FiAuthStatesLoginAuthResolve_magicLink_resolveFunc(
    fiStateService: FiStateService,
    $transition$: Transition,
) {
    return fiStateService.getParams($transition$).magicLink;
}

export function FiAuthStatesLoginAuthResolve_autoLogin_resolveFunc(
    fiStateService: FiStateService,
    $transition$: Transition,
) {
    return fiStateService.getParams($transition$).autoLogin;
}

export function FiAuthStatesLoginAuthResolve_pageTitle_resolveFunc(pageTitleService: PageTitleService) {
    return pageTitleService.setTitle('Login');
}

export function FiAuthStatesLoginAuthResolve_checkAuthenticated_resolveFunc(
    fiStateService: FiStateService,
    $transition$: Transition,
) {
    return fiStateService.getParams($transition$).checkAuthenticated;
}
